import { render } from "./g-collapse-transition.vue?vue&type=template&id=38432bd4&ts=true"
import script from "./g-collapse-transition.vue?vue&type=script&lang=tsx"
export * from "./g-collapse-transition.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__